const getRealLayoutSize = (r) => r;
const getPixelSizeForLayoutSize = (r) => r;
const Default_Src = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAIAAAACDbGyAAABYWlDQ1BrQ0dDb2xvclNwYWNlRGlzcGxheVAzAAAokWNgYFJJLCjIYWFgYMjNKykKcndSiIiMUmB/yMAOhLwMYgwKicnFBY4BAT5AJQwwGhV8u8bACKIv64LMOiU1tUm1XsDXYqbw1YuvRJsw1aMArpTU4mQg/QeIU5MLikoYGBhTgGzl8pICELsDyBYpAjoKyJ4DYqdD2BtA7CQI+whYTUiQM5B9A8hWSM5IBJrB+API1klCEk9HYkPtBQFul8zigpzESoUAYwKuJQOUpFaUgGjn/ILKosz0jBIFR2AopSp45iXr6SgYGRiaMzCAwhyi+nMgOCwZxc4gxJrvMzDY7v////9uhJjXfgaGjUCdXDsRYhoWDAyC3AwMJ3YWJBYlgoWYgZgpLY2B4dNyBgbeSAYG4QtAPdHFacZGYHlGHicGBtZ7//9/VmNgYJ/MwPB3wv//vxf9//93MVDzHQaGA3kAFSFl7jXH0fsAAAA4ZVhJZk1NACoAAAAIAAGHaQAEAAAAAQAAABoAAAAAAAKgAgAEAAAAAQAAAAWgAwAEAAAAAQAAAAUAAAAAXGI+ywAAABVJREFUCB1j/PLlCwMSYEJig5ik8gHg6ALmmqX49wAAAABJRU5ErkJggg==';
export const defaultConfig = {
    quality: 85,
    defaultSrc: Default_Src,
    defaultSrcOnError: Default_Src,
    observerOptions: {
        rootMargin: '50px 0px 5px 0px',
        threshold: 0.1,
    },
    getRealLayoutSize,
    getPixelSizeForLayoutSize,
};
